import { createContext, useReducer } from 'react'
import { reducer } from './Reducer';

export const GlobalContext = createContext("Initial Value");

let data = {
    // clickLoad: false,
    // darkTheme: true,
    user: {},
    isLogin: null,
    token:"",
    baseUrl: "https://salesinsighthub.opraviq.com"
    // saleToken:"",
    // saleIsLogin: false,
    // ipAddress: "",
    // reloadTime: null,
    // reloadToggle: false,
    // baseUrl: "https://vpserver.org/HRMS-v3-b/",
    // // baseUrl: "http://192.168.100.108/HRMS-v3-b/backend/",
    // baseUrl2: "https://vpserver.org/sale-system/api/",
    // mainPageLoad: false,
    // basePath: "",
    // userList : [],
    // getDropdowns: {},
    // coverPhotos: [],
    // timeIn: "",
    // timeOut: "",
    // hrs: "",
    // timeLoader: false
    // basePath: "/new-dashboard" //For Live
}

export default function ContextProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, data);
    return (
        <GlobalContext.Provider value={{ state, dispatch }}>
            {children}
        </GlobalContext.Provider>
    )
}